import React, { useEffect } from 'react';
import { Button, Card, Col, Container, Row, Nav, Navbar, Table, Image, Badge, CardGroup } from 'react-bootstrap';
import { ArrowRight, ArrowUpRight, Check, X } from 'react-feather';
import { Helmet } from 'react-helmet-async';
import moreBackground from './more-is-better.svg';
import YouHaveTheBest from './you-have-the-best-bot.png';
import UprateToEnhanceDispute from './uprade_to_enhance_dispute.png';

import CurrentPlan from './current-plan.png';
import NinePlan from './999-plan.png';
import premiumStars from './stars-premium.svg';
import imagineMailing from '../../assets/img/enhanced-landing.png';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCurrentPlan, updateNextPlan, fetchPackagesDetail, blankCurrentPlan, updateCurrentPlan } from '../../redux/slices/EnhanceDisputeSlice';
import $ from 'jquery';
import NotyfContext from '../../contexts/NotyfContext';
import { callUserActvity, fetchNotification, setNotifcationBedge } from '../../redux/slices/CommonSlice';
import { blankGetAllReportData, getAllReport } from '../../redux/slices/ReportSlice';
import EnhancedFactory from '../../assets/img/disputely-enhanced-factory.png';
import DiyStandard from '../../assets/img/standard-diy.png';
import WdfuStandard from '../../assets/img/standard-wd4u.png';
import MoreIsBetter from './more-is-better-bot.png';
import BureauGroup from './dispute-group-1.png';
import { createDisputeLatter } from '../../redux/slices/CommonSlice';
import OneArmHold from '../../assets/img/one-arm-bot-sign.png';
import Experian from '../../assets/img/brands/experian.svg';
import Equifax from '../../assets/img/brands/equifax.svg';
import TransUnion from '../../assets/img/brands/transunion.svg';
import Loader from '../../components/Loader';
import CDIA from '../../assets/img/cdia.png';
import CFPB from '../../assets/img/cfpb.png';
import Creditor from '../../assets/img/creditor.png';
import USFTC from '../../assets/img/usftc.png';
import Chex from '../../assets/img/chexsystems.png';
import LexisNexis from '../../assets/img/lexisnexis.svg';
import Pacer from '../../assets/img/pacer.png';
import Joyride from 'react-joyride';
import InfoPopover from '../../components/new/InfoPopover';
import { useNavigate } from 'react-router-dom';

const EnhanceDisputesPlan = () => {
  const navigate = useNavigate()
  const notyf = React.useContext(NotyfContext);
  const dispatch = useDispatch();

  const packages = useSelector(state => state.enhanceDispute.packages);
  const mailingOption = useSelector(state => state.enhanceDispute.mailingOption);
  const currentPlan = useSelector(state => state.enhanceDispute.currentPlan);
  const packagesDetail = useSelector(state => state.enhanceDispute.packagesDetail);
  const currentPlanStatus = useSelector(state => state.enhanceDispute.currentPlanStatus);
  const currentPlanStatusMsg = useSelector(state => state.enhanceDispute.currentPlanStatusMsg);

  const reportStatus = useSelector(state => state.reports.getAllReportStatus);
  const getAllReportData = useSelector(state => state.reports.getAllReportData);

  const [isSubmitting, setIsSubmitting] = React.useState(false);

  React.useEffect(() => {
    let obj = {
      clientId: 1,
      roundid: 1,
    };
    dispatch(blankCurrentPlan());
    dispatch(fetchCurrentPlan());
    dispatch(getAllReport(obj));
    dispatch(fetchPackagesDetail());
  }, []);

  React.useEffect(() => {
    return () => {
      dispatch(blankGetAllReportData());
    };
  }, []);

  React.useEffect(() => {
    if (currentPlanStatus === 'idle' || currentPlanStatus == 'updated.success') {
      dispatch(fetchCurrentPlan());
    }
    if (currentPlanStatus == 'updated.success' || currentPlanStatus == 'updated.failed') {
      notyf.open({
        type: currentPlanStatus == 'updated.success' ? 'success' : 'danger',
        message: currentPlanStatusMsg,
        duration: '3000',
        ripple: false,
        dismissible: false,
        position: {
          x: 'right',
          y: 'top',
        },
      });
      setIsSubmitting(false)
      if (currentPlanStatus === 'updated.success') {
        setTimeout(() => {
          navigate('/dispute-center', { replace: true });
        }, 1000);
      }
    }
  }, [currentPlanStatus, dispatch]);

  const updatePlan = (plan, mailing) => {
    setIsSubmitting(true)
    const isDowngrade = (plan == 1 && mailing == 1 && mailingOption > 1) || (plan == 1 && mailing == 2 && parseInt(currentPlan) > 1) || (plan == 1 && mailing == 1 && parseInt(currentPlan) > 1);
    const confirmation = {
      message: "",
      buttonText: ""
    }
    const planNames = ['standard', 'standard w/mailing', 'enhanced'];
    if(plan == currentPlan && mailing == mailingOption){
      confirmation.message = "Are you sure you want to continue with your current plan?";
      confirmation.buttonText = "Confirm";
    }else{
      confirmation.message = isDowngrade ? `Are you sure you want to downgrade your plan to ${planNames[mailing - 1]}?` : `Confirming you want to upgrade your plan to ${planNames[plan]}!`;
      confirmation.buttonText = isDowngrade ? 'Downgrade' : 'Upgrade';
    }
    
  
    $.confirm({
      title: 'Plan Confirmation!',
      content: confirmation.message,
      type: 'blue',
      buttons: {
        ok: {
          text: confirmation.buttonText,
          btnClass: 'btn btn-outline-primary',
          keys: ['enter'],
          action: function () {
            if(plan == 1 && mailing == 1) {
              dispatch(updateCurrentPlan({ planId: plan, mailingOption: mailing }));
              dispatch(fetchNotification());
              dispatch(setNotifcationBedge(true));
            }else {
              const standard = plan == 1 && mailing == 2;
              dispatch(callUserActvity(`${standard ? 'Standard w/Mailing' : 'Enhanced Disputes'} Plan Selected`));
              notyf.open({
                type: 'success',
                message: `${standard ? 'Standard w/Mailing' : 'Enhanced Disputes'} Plan Selected`,
                duration: 3000,
                ripple: false,
                dismissible: false,
                position: {
                  x: 'right',
                  y: 'top',
                },
              });
              setTimeout(() => {
                navigate(`/checkout/${standard ? 'standard' : 'enhanced'}`);
              }, 1000);
            }
            
          },
        },
        cancel: function () {
          setIsSubmitting(false)
        },
      },
    });
  };
  if (reportStatus === 'loading' || isSubmitting) {
    return <Loader />;
  }

  return (
    <React.Fragment>
      <Helmet title='Enhanced Disputes Plan' />
      <style>
        {`
          .steps {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 2rem;
            position: relative;
          }
          .step-button {
            width: 30px;
            height: 30px;
            border-radius: 50%;
            border: none;
            background-color: var(--prm-gray);
            transition: .4s;
          }
          .step-button[aria-expanded="true"] {
            width: 25px;
            height: 25px;
            font-size: 12px;
          }
          .done {
            background-color: var(--prm-color);
            color: #fff;
          }
          .step-item {
            z-index: 10;
            text-align: center;
            margin-top: 1.5rem;
          }
          #progress {
            -webkit-appearance: none;
            position: absolute;
            width: 100%;
            z-index: 5;
            border: #C8CCDF dashed;
            border-width: 3px 0px 0px 0px;
            top: 6.75rem;
          }
          /* to customize progress bar */

          #progress::-webkit-progress-value {
            background-color: var(--prm-color);
            transition: .5s ease;
          }
          #progress::-webkit-progress-bar {
            background-color: var(--prm-gray);
          }
          .step-title {
            width: 120px;
            color: #7C84A5;
            font-weight: 400;
            text-align: center;
            margin-bottom:1.5rem;
          }
          .completed .step-title {
            text-align: center;
            font-weight: 500;
            color: #000E4E
          }
          .active .step-title {
            font-weight: 500;
            color: #0076FF
          }
          .shadow-more {
            box-shadow: 0 6px 40px 0 rgb(var(--bs-primary-rgb), 0.5) !important;
          }
            .card {
              grid-template-rows: auto 150px 150px auto auto;
            }
            .you-have-best-plan {
              width: 220px;
              position: absolute;
              top: -144px;
              left: 24px;
            }
            .bureauImages {
              height: 240px;
            }


            @media (max-width: 768px) {
              html {
                  overflow-x:hidden !important;
              }
              .you-have-best-plan {
                width: 220px;
                position: absolute;
                top: -183px;
                left: 4px;
              }
              #standard, #standardMailing {
                margin-top: 3rem
              }
              .bureauImages {
                height: 200px;
              }

              #enhanced {
                margin-top: 8rem;
                top: -193px;
                left: 0px;
              }
            }

        `}
      </style>
      <Container fluid className='container-fluid-1335 pb-5'>
        <Row>
          <h1 className='mb-0 mb-md-5' style={{ textAlign: 'center', marginBottom: '4rem' }}>
            Upgrade Your New Disputes Plan
          </h1>
        </Row>
        <Row>
          {/* ************* STANDARD ************* */}
          <Col xs={12} lg={4} id='standard' className='mt-0 mt-' onClick={() => updatePlan(1, 1)}>
            <Card className={`${currentPlan == 1 && mailingOption == 1 ? 'border-4 border border-secondary rounded-4' : 'border-0 cursor-pointer'} h-100`}>
              {currentPlan == 1 && mailingOption == 1 ? (
                <Badge bg='primary' className='w-25 mx-auto my-3'>
                  Current Plan
                </Badge>
              ) : (
                <Badge bg='primary' className='w-25 mx-auto my-3 visibility-hidden'>
                  Current Plan
                </Badge>
              )}
              <h2 className='text-center'>Standard</h2>
              <Card.Header className='py-3 border-0 bg-white rounded-4' style={{ height: '225px' }}>
                <div className='display-2 fw-bold text-secondary text-center mb-3'>FREE</div>
                <h4 className='text-center text-secondary'>Personalized Disputes for All 3 Major Bureaus</h4>
                <hr className='border border-1 border-secondary opacity-100 my-3 w-50 mx-auto' />
                <div className='text-center'>You handle the processing and mailing on your own.</div>
              </Card.Header>
              <Card.Header className='p-3 border-0 bg-white rounded-4 d-flex w-100 flex-row align-items-center bureauImages'>
                <Col xs={8}>
                  <Card.Img className='fixed-height' variant='top' src={DiyStandard} />
                </Col>
                <Col xs={4} className='d-flex flex-column justify-content-center align-items-center h-50'>
                  <Image src={Experian} alt='Experian' className='w-100 my-auto' />
                  <Image src={Equifax} alt='Equifax' className='my-auto w-100' />
                  <Image src={TransUnion} alt='TransUnion' className='w-100 my-auto' />
                </Col>
              </Card.Header>
              <Card.Body>
                <Card className='mb-0 rounded-3 border border-4 shadow h-100'>
                  <Card.Body className='bg-white p-0 rounded-3'>
                    <div className='d-flex flex-row px-3 py-3'>
                      <div href='#home' className='navbar-brand'>
                        <div className='bg-light-gray lh-1 p-1 rounded-5'>
                          <Check className='m-auto p-1 bg-white text-secondary rounded-circle h-auto border border-secondary border-1' width={30} height={30} strokeWidth={5} color={'var(--bs-secondary)'} />
                        </div>
                      </div>
                      <span className='me-auto ms-3 h3 mb-0 text-secondary navbar-brand'>Standard</span>
                      <button type='button' className='text-secondary border-0 py-1 px-3 bg-opacity-25 btn btn-light d-none d-md-block'>
                        FREE
                      </button>
                    </div>
                    <hr className='w-90 mx-auto opacity-25 text-light-gray' />
                    <Row className='row px-3 px-md-5 pb-4 pt-2'>
                      <Col xs={12} className='rounded-4 mx-auto bg-light p-3'>
                        <p className='mb-1 fs-5 text-light-gray'>You will get</p>
                        <ul>
                          <li>{packagesDetail.length > 0 && packagesDetail[0].total_negative} Negative items (Dispute)</li>
                          <li>{packagesDetail.length > 0 && packagesDetail[0].total_destination} Major Reporting Agencies (With me)</li>
                          <li>{packagesDetail.length > 0 && packagesDetail[0].total_letter} Total Letters</li>
                          <li>Credit Bureau Disputes</li>
                          <li>Dispute Letter (Mail Only)</li>
                          <li>Personal Information Disputes Not Included</li>
                        </ul>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Card.Body>

              <Card.Footer className='border-0'>
                {currentPlan == 1 && mailingOption == 1 ? (
                  <Button variant='primary' className='w-100'>
                    Current Plan
                  </Button>
                ) : (
                  <Button variant='primary' className='w-100'>
                    Choose Standard Plan
                  </Button>
                )}
              </Card.Footer>
            </Card>
          </Col>
          {/* ************* STANDARD WITH MAILING ************* */}
          <Col xs={12} lg={4} id='standardMailing' className='cursor-pointer' onClick={() => updatePlan(1, 2)}>
            <Card className={`${currentPlan == 1 && mailingOption == 2 ? 'border-4 border border-secondary rounded-4' : 'border-0 shadow'} h-100 `}>
              {currentPlan == 1 && mailingOption == 2 ? (
                <Badge bg='primary' className='w-25 mx-auto my-3'>
                  Current Plan
                </Badge>
              ) : (
                <Badge bg='primary' className='w-25 mx-auto my-3 visibility-hidden'>
                  Current Plan
                </Badge>
              )}

              <h2 className='text-center'>Standard w/ Mailing</h2>
              <Card.Header className='py-3 border-0 bg-white rounded-4' style={{ height: '225px' }}>
                <div className='display-2 fw-bold text-secondary text-center mb-3'>${packages[1] && packages[1]}</div>
                <h4 className='text-center text-secondary'>Expedited Processing &amp; Mailing w/ Disputely</h4>
                <hr className='border border-1 border-secondary opacity-100 my-3 w-50 mx-auto' />
                <div className='text-center'>We handle the mailing for you.</div>
              </Card.Header>
              <Card.Header className='p-3 border-0 bg-white rounded-4 d-flex w-100 flex-row align-items-center bureauImages'>
                <Col xs={8}>
                  <Card.Img className='fixed-height' variant='top' src={WdfuStandard} />
                </Col>
                <Col xs={4} className='d-flex flex-column justify-content-center align-items-center h-50'>
                  <Image src={Experian} alt='Experian' className='w-100 my-auto' />
                  <Image src={Equifax} alt='Equifax' className='my-auto w-100' />
                  <Image src={TransUnion} alt='TransUnion' className='w-100 my-auto' />
                </Col>
              </Card.Header>
              <Card.Body>
                <Card className='mb-0 rounded-3 border border-4 shadow h-100'>
                  <Card.Body className='bg-white p-0 rounded-3'>
                    <div className='d-flex flex-row px-3 py-3'>
                      <div href='#home' className='navbar-brand'>
                        <div className='bg-light-gray lh-1 p-1 rounded-5'>
                          <Check className='m-auto p-1 bg-white text-secondary rounded-circle h-auto border border-secondary border-1' width={30} height={30} strokeWidth={5} color={'var(--bs-secondary)'} />
                        </div>
                      </div>
                      <span className='me-auto ms-1 ms-md-3 h3 mb-0 text-secondary navbar-brand'>Standard w/ Mailing</span>
                      <button type='button' className='text-secondary border-0 py-1 px-3 bg-opacity-25 btn btn-light d-none d-md-block'>
                        ${packages[1] && packages[1]}
                      </button>
                    </div>
                    <hr className='w-90 mx-auto opacity-25 text-light-gray' />
                    <Row className='row px-3 px-md-5 pb-4 pt-2'>
                      <Col xs={12} className='rounded-4 mx-auto bg-light p-3'>
                        <p className='mb-1 fs-5 text-light-gray'>You will get</p>
                        <ul>
                          <li>Expedited Processing & Mailing w/ Disputely</li>
                          <li>{packagesDetail.length > 0 && packagesDetail[0].total_negative} Negative items (Dispute)</li>
                          <li>{packagesDetail.length > 0 && packagesDetail[0].total_destination} Major Reporting Agencies (With me)</li>
                          <li>{packagesDetail.length > 0 && packagesDetail[0].total_letter} Total Letters</li>
                          <li>Credit Bureau Disputes</li>
                          <li>Dispute Letter (Mail Only)</li>
                          <li>Personal Information Disputes Not Included</li>
                        </ul>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Card.Body>
              <Card.Footer className='border-0'>
                {currentPlan == 1 && mailingOption == 2 ? (
                  <Button variant='primary' className='w-100 mx-auto my-3'>
                    Current Plan
                  </Button>
                ) : (
                  <Button variant='primary' className='w-100'>
                    Mail It For Me!
                  </Button>
                )}
              </Card.Footer>
            </Card>
          </Col>
          {/* ************* ENHANCED ************* */}
          <Col xs={12} lg={4} id='enhanced' className='cursor-pointer' onClick={() => updatePlan(2, mailingOption)}>
            <Card className={`${currentPlan == 2 ? 'border-4 border border-primary rounded-4' : 'border-0 shadow'} position-relative h-100`}>
              {currentPlan == 1 && <Image src={MoreIsBetter} alt='More Is Better' className='' style={{ width: '220px', position: 'absolute', top: '-139px', left: '94px' }} />}
              {currentPlan == 2 && (
                <div className='text-center h2 mt-5 mt-md-0' style={{ textAlign: 'center', width: '300px', position: 'absolute', top: '-50px', left: '69px' }}>
                  <Image src={YouHaveTheBest} alt='The Best Plan!' className='you-have-best-plan mt-5' />
                </div>
              )}
              <Badge bg='primary' className='w-25 mx-auto my-3 visibility-hidden'>
                Current Plan
              </Badge>
              <h2 className='text-center'>Enhanced</h2>
              <Card.Header className='py-3 border-0 bg-white rounded-4' style={{ height: '225px' }}>
                <div className='display-2 fw-bold text-dark-blue text-center mb-3'>${packages[2] && packages[2]}</div>
                <div style={{ height: '75px', margin: 'auto' }}>
                  <h4 className='text-center'>+Expedited Processing & Mailing Included</h4>
                  <hr className='border border-1 border-card-cap opacity-100 my-3 w-50 mx-auto' />
                  <div className='text-center'>The most comprehensive, customized dispute process on the planet.</div>
                </div>
              </Card.Header>
              <Card.Header className='p-3 border-0 bg-white rounded-4 d-flex w-100 flex-row align-items-center bureauImages'>
                <Col xs={7}>
                  <Card.Img className='fixed-height' variant='top' src={EnhancedFactory} />
                </Col>
                <Col className='d-flex flex-column justify-content-center align-items-center h-100 px-2'>
                  <Image src={Experian} alt='Experian' className='w-100 my-auto' />
                  <Image src={Equifax} alt='Equifax' className='my-auto w-100' />
                  <Image src={TransUnion} alt='TransUnion' className='w-100 my-auto' />
                  <Image src={CDIA} alt='TransUnion' className='w-100 my-auto' />
                  <Image src={CFPB} alt='TransUnion' className='w-100 my-auto' />
                </Col>
                <Col className='d-flex flex-column justify-content-center align-items-center h-100 px-2'>
                  <Image src={Pacer} alt='Equifax' className='my-auto w-100' />
                  <Image src={Chex} alt='TransUnion' className='w-100 my-auto' />
                  <Image src={LexisNexis} alt='TransUnion' className='w-100 my-auto' />
                  <Image src={Creditor} alt='Creditor' className='w-70 my-auto' />
                  <h6 className='text-center my-auto'>And More...</h6>
                </Col>
              </Card.Header>
              <Card.Body>
                <Card
                  style={{
                    backgroundImage: `url(${moreBackground})`,
                    backgroundRepeat: 'no-repeat',
                  }}
                  className='mb-0 rounded-3 bg-primary shadow-more rounded-3 p-3 h-100 '>
                  <Card.Body className='bg-transparent p-0 rounded-3'>
                    <nav className='p-0 shadow-none navbar navbar-expand-lg navbar-light'>
                      <Container fluid>
                        <a href='#home' className='navbar-brand'>
                          <div className='bg-light-blue lh-1 p-2 d-flex rounded-circle'>
                            <Image src={premiumStars} alt='premium stars' fill='var(--bs-primary)' className='text-primary' width={10} height={10} />
                          </div>
                        </a>
                        <span className='me-auto fw-bold mb-0 text-white navbar-brand'>Enhanced</span>
                        <a role='button' className='nav-link disabled' aria-disabled='true'>
                          <div className='text-white rounded border-0 py-1 px-3 bg-white bg-opacity-25 d-none d-md-block'>${packages[2] && packages[2]}</div>
                        </a>
                      </Container>
                    </nav>
                    <hr className='w-90 mx-auto opacity-75 text-white' />
                    <Row className='row'>
                      <div className='mx-auto bg-light bg-opacity-25 rounded-4 py-3 col-lg-10'>
                        <p className='mb-1 fs-5 text-white'>You will get</p>
                        <table className='mb-0 table table-borderless'>
                          <tbody>
                            <tr>
                              <td colSpan={1} className='h2 text-white w-10'>
                                {packagesDetail.length > 0 && packagesDetail[1].total_negative}
                              </td>
                              <td className='text-regular-18 text-white text-left'>Negative items (Dispute)</td>
                            </tr>
                            <tr>
                              <td colSpan={1} className='h2 text-white w-10'>
                                {packagesDetail.length > 0 && packagesDetail[1].total_destination}
                              </td>
                              <td className='text-regular-18 text-white text-left'>Major Reporting Agencies (With me)</td>
                            </tr>
                            <tr>
                              <td colSpan={1} className='h2 text-white w-10'>
                                {packagesDetail.length > 0 && packagesDetail[1].total_letter}
                              </td>
                              <td className='text-regular-18 text-white text-left'>Total Letters</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </Row>
                    <hr className='w-90 mx-auto opacity-75 text-white' />
                    <Row>
                      <div className='mx-auto bg-light rounded-4 py-3 col-lg-10'>
                        <table className='mb-0 table table-borderless'>
                          <tbody>
                            <tr>
                              <td>
                                <Check width={20} height={20} strokeWidth={4} className='m-auto p-1 bg-primary text-white rounded-circle h-auto border border-primary border-1' />
                              </td>
                              <td className='text-regular-16 text-primary text-left'>Expedited Personal Information Disputes</td>
                            </tr>
                            <tr>
                              <td>
                                <Check width={20} height={20} strokeWidth={4} className='m-auto p-1 bg-primary text-white rounded-circle h-auto border border-primary border-1' />
                              </td>
                              <td className='text-regular-16 text-primary text-left'>Credit Bureau Disputes, All Bureaus</td>
                            </tr>
                            <tr>
                              <td>
                                <Check width={20} height={20} strokeWidth={4} className='m-auto p-1 bg-primary text-white rounded-circle h-auto border border-primary border-1' />
                              </td>
                              <td className='text-regular-16 text-primary text-left'>Personal Information Disputes</td>
                            </tr>
                            <tr>
                              <td>
                                <Check width={20} height={20} strokeWidth={4} className='m-auto p-1 bg-primary text-white rounded-circle h-auto border border-primary border-1' />
                              </td>
                              <td className='text-regular-16 text-primary text-left'>Credit Bureaus Disputes</td>
                            </tr>
                            <tr>
                              <td>
                                <Check width={20} height={20} strokeWidth={4} className='m-auto p-1 bg-primary text-white rounded-circle h-auto border border-primary border-1' />
                              </td>
                              <td className='text-regular-16 text-primary text-left'>Alternative Credit Bureau Disputes</td>
                            </tr>
                            <tr>
                              <td>
                                <Check width={20} height={20} strokeWidth={4} className='m-auto p-1 bg-primary text-white rounded-circle h-auto border border-primary border-1' />
                              </td>
                              <td className='text-regular-16 text-primary text-left'>Regulatory Agency Disputes</td>
                            </tr>
                            <tr>
                              <td>
                                <Check width={20} height={20} strokeWidth={4} className='m-auto p-1 bg-primary text-white rounded-circle h-auto border border-primary border-1' />
                              </td>
                              <td className='text-regular-16 text-primary text-left'>Data Furnisher Disputes</td>
                            </tr>
                            <tr>
                              <td>
                                <Check width={20} height={20} strokeWidth={4} className='m-auto p-1 bg-primary text-white rounded-circle h-auto border border-primary border-1' />
                              </td>
                              <td className='text-regular-16 text-primary text-left'>Inquiry Disputes</td>
                            </tr>
                            <tr>
                              <td>
                                <Check width={20} height={20} strokeWidth={4} className='m-auto p-1 bg-primary text-white rounded-circle h-auto border border-primary border-1' />
                              </td>
                              <td className='text-regular-16 text-primary text-left'>Demand Disputes</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </Row>
                  </Card.Body>
                </Card>
              </Card.Body>
              <Card.Footer className='border-0'>
                {currentPlan == 2 ? (
                  <Button variant='primary' className='w-100'>
                    Current Plan
                  </Button>
                ) : (
                  <Button variant='primary' className='w-100'>
                    Go Enhanced
                  </Button>
                )}
              </Card.Footer>
            </Card>
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  );
};

export default EnhanceDisputesPlan;
